<template>
  <v-card
    class="recommendation-card pa-6 text-left"
    @click="$emit('click')"
    data-test-id="recommendation-card"
  >
    <div class="recommendation-card__header d-flex align-center">
      <Icon :icon="icon" :color="iconColor" large tile />
      <Typography variant="h-5" class="flex-grow-1">{{ title }}</Typography>
      <Icon icon="mdi-chevron-right" />
    </div>
    <Typography variant="body-1" class="text-center">
      {{ content }}
    </Typography>
  </v-card>
</template>

<script>
import Icon from "@/components/generic/Icon.vue";
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "RecommendationCard",
  components: {
    Icon,
    Typography,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: "systemPrimary",
    },
  },
  emits: ["click"],
};
</script>

<style scoped>
.recommendation-card {
  display: flex;
  flex-direction: column;
  gap: 17px;
  height: 100%;
  border-radius: 8px;
}

.recommendation-card__header {
  gap: 16px;
  width: 100%;
}
</style>
